(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
(() => {
  function buildArticleToc() {
    document.querySelectorAll('[data-aairsk-article-content]').forEach((content) => {
      if (content.dataset.tocReady === 'true') return;
      const headings = Array.from(content.querySelectorAll('h2, h3, h4')).filter(
        heading => heading.textContent.trim() && !heading.closest('[data-toc-ignore], nav, aside, [hidden]')
      );
      const firstH2 = headings.find(heading => heading.tagName === 'H2');
      if (!firstH2 || headings.length < 2) return;

      const usedIds = new Set(Array.from(document.querySelectorAll('[id]'), element => element.id));
      const nav = document.createElement('nav');
      nav.className = 'aairsk-article-toc';
      nav.setAttribute('aria-label', 'Table of contents');
      const details = document.createElement('details');
      details.open = true;
      const summary = document.createElement('summary');
      const title = document.createElement('span');
      title.textContent = 'Table of Contents';
      const toggleLabel = document.createElement('span');
      toggleLabel.className = 'aairsk-toc-main-toggle';
      toggleLabel.textContent = 'Collapse';
      summary.append(title, toggleLabel);
      details.addEventListener('toggle', () => {
        toggleLabel.textContent = details.open ? 'Collapse' : 'Expand';
      });
      const list = document.createElement('ol');
      const stack = [];
      let h2Number = 0;

      headings.forEach((heading, index) => {
        // Preserve existing unique anchors; avoid collisions across the page.
        const duplicateId = heading.id && Array.from(document.querySelectorAll('[id]'))
          .some(element => element !== heading && element.id === heading.id);
        if (!heading.id || duplicateId) {
          const base = 'aairsk-article-section-' + (index + 1);
          let id = base;
          let suffix = 2;
          while (usedIds.has(id)) id = base + '-' + suffix++;
          heading.id = id;
          usedIds.add(id);
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        const headingText = heading.textContent.trim();
        if (heading.tagName === 'H2') {
          h2Number += 1;
          // Strip a leading section number only in the TOC; keep the article intact.
          const cleanTitle = headingText.replace(
            /^(?:(?:\d+[.．、:)）]|\(\d+\)|（\d+）)\s*|\d+\s*[-–—]\s+)(?=\S)/u,
            ''
          );
          link.textContent = h2Number + '. ' + cleanTitle;
        } else {
          link.textContent = headingText;
        }
        link.setAttribute('href', '#' + encodeURIComponent(heading.id));
        const row = document.createElement('div');
        row.className = 'aairsk-toc-row';
        row.append(link);
        item.append(row);
        const level = Number(heading.tagName.slice(1));
        while (stack.length && stack[stack.length - 1].level >= level) stack.pop();
        const parent = stack[stack.length - 1];
        if (parent) {
          if (!parent.children) {
            const children = document.createElement('ol');
            const base = parent.heading.id + '-toc-children';
            let id = base;
            let suffix = 2;
            while (usedIds.has(id)) id = base + '-' + suffix++;
            children.id = id;
            usedIds.add(id);
            children.hidden = true;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'aairsk-toc-toggle';
            const chevron = document.createElement('span');
            chevron.className = 'aairsk-toc-chevron';
            chevron.setAttribute('aria-hidden', 'true');
            button.append(chevron);
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-controls', id);
            const title = parent.heading.textContent.trim();
            button.setAttribute('aria-label', 'Expand subsections: ' + title);
            button.addEventListener('click', () => {
              const expanded = button.getAttribute('aria-expanded') !== 'true';
              children.hidden = !expanded;
              button.setAttribute('aria-expanded', String(expanded));
              button.setAttribute('aria-label', (expanded ? 'Collapse' : 'Expand') + ' subsections: ' + title);
            });
            parent.row.prepend(button);
            parent.item.append(children);
            parent.children = children;
          }
          parent.children.append(item);
        } else {
          list.append(item);
        }
        stack.push({ level, item, row, heading, children: null });
      });

      details.append(summary, list);
      nav.append(details);
      firstH2.before(nav);
      content.dataset.tocReady = 'true';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildArticleToc, { once: true });
  } else {
    buildArticleToc();
  }
  document.addEventListener('shopify:section:load', buildArticleToc);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
